// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MeepEarth from './MeepEarth';
import SharePage from './SharePage';

function App() {
  return (
    <Router>
      <Routes>
        {/* Landing page route */}
        <Route path="/" element={<MeepEarth />} />
        
        {/* Share page for App Clip */}
        <Route path="/share" element={<SharePage />} />
        
        {/* Your main app routes - comment out for now if MainApp doesn't exist */}
        {/* <Route path="/app/*" element={<MainApp />} /> */}
        
        {/* 404 fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;